import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function CollectionPage() {
    const { slug } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        api.get(`/collections/${slug}`)
            .then(r => setData(r.data))
            .catch(() => setData(null))
            .finally(() => setLoading(false));
    }, [slug]);

    if (loading) return <div className="px-6 md:px-12 lg:px-24 py-20 text-[color:var(--ms-muted)] text-sm">Caricamento…</div>;
    if (!data) return (
        <div className="px-6 md:px-12 lg:px-24 py-32 text-center" data-testid="collection-notfound">
            <h1 className="font-display text-4xl text-[color:var(--ms-charcoal)]">Collezione non trovata</h1>
            <Link to="/shop" className="overline mt-6 inline-block link-underline">TORNA ALLO SHOP</Link>
        </div>
    );

    const { collection, products } = data;

    return (
        <div data-testid={`collection-${collection.slug}`}>
            <section className="relative h-[42vh] min-h-[300px] bg-[color:var(--ms-cream)] overflow-hidden">
                {collection.cover_image ? (
                    <>
                        <img src={collection.cover_image} alt={collection.title} className="absolute inset-0 w-full h-full object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/20 to-[color:var(--ms-ivory)]" />
                    </>
                ) : (
                    <div className="absolute inset-0 bg-gradient-to-b from-[color:var(--ms-cream)] to-[color:var(--ms-ivory)]" />
                )}
                <div className="relative h-full flex flex-col justify-end px-6 md:px-12 lg:px-24 pb-12">
                    <div className={`overline mb-3 ${collection.cover_image ? "text-[color:var(--ms-warm-white)]" : ""}`}>Collezione</div>
                    <h1 className={`font-display text-5xl sm:text-6xl tracking-tight ${collection.cover_image ? "text-[color:var(--ms-warm-white)]" : "text-[color:var(--ms-charcoal)]"}`}>{collection.title}</h1>
                    {collection.description && (
                        <p className={`mt-3 max-w-2xl text-base font-light ${collection.cover_image ? "text-[color:var(--ms-warm-white)]/90" : "text-[color:var(--ms-muted)]"}`}>{collection.description}</p>
                    )}
                </div>
            </section>

            <section className="px-6 md:px-12 lg:px-24 py-16">
                <div className="text-[color:var(--ms-muted)] text-sm mb-8" data-testid="collection-count">{products.length} capi</div>
                {products.length === 0 ? (
                    <div className="panel py-32 text-center text-[color:var(--ms-muted)]" data-testid="collection-empty">
                        Presto in arrivo. Iscriviti alla newsletter per accedere prima ai nuovi capi.
                    </div>
                ) : (
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-10" data-testid="collection-grid">
                        {products.map(p => <ProductCard key={p.id} product={p} />)}
                    </div>
                )}
            </section>
        </div>
    );
}
